import { Theme } from '@mui/material';

export const MuiTextFieldStyled = (theme: Theme) => {
    theme.components = {
        ...theme.components,
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-notchedOutline': {
                       borderColor: theme.palette.primary.main
                   }
                },
                
            },
        },
    };
};
